import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import type { UpdateCandidateRequest, Candidate } from '../../types';
import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import type { AxiosError } from 'axios';

export const useUpdateCandidate = (
  id: string
): UseMutationResult<
  Candidate,
  AxiosError<TFormErrorResponse>,
  UpdateCandidateRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_CANDIDATE, id],
    mutationFn: (params: UpdateCandidateRequest) =>
      candidatesApi.updateCandidate(id, params),
  });
};
